import { LevelGranulometryInitialEntries } from '../../../LevelGranulometry';
import { SQUARE_METER_SCALE } from '../../../../../../constants/appConstants';
import { getLevelAlreadyCalculatedRealBuiltSurface } from '../../surfaces/getLevelAlreadyCalculatedRealBuiltSurface';

export const getTopLevelRbsRulerWidth = (
  levelGranulometry: LevelGranulometryInitialEntries
): number =>
  getLevelAlreadyCalculatedRealBuiltSurface(levelGranulometry).value * SQUARE_METER_SCALE;
